import direct from 'ml-direct';
export function directOptimization(data, sumOfShapes, options) {
    const { minValues, maxValues, directOptions = {} } = options;
    const objectiveFunction = getObjectiveFunction(data, sumOfShapes);
    const result = direct(objectiveFunction, minValues, maxValues, directOptions);
    const { optima } = result;
    return {
        error: result.minFunctionValue,
        iterations: result.iterations,
        parameterValues: optima[0],
    };
}
function getObjectiveFunction(data, sumOfShapes) {
    const { x, y } = data;
    const nbPoints = x.length;
    return (parameters) => {
        const fct = sumOfShapes(parameters);
        let error = 0;
        for (let i = 0; i < nbPoints; i++) {
            error += Math.pow(y[i] - fct(x[i]), 2);
        }
        return error;
    };
}
//# sourceMappingURL=directOptimization.js.map